export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/PE-e229e0f7a622b2a5d2f61c87ea955dd2.png";